import { easeInOut, motion } from "framer-motion";

const transition = {
  duration: 3,
  yoyo: Infinity,
  ease: easeInOut,
  repeat: Infinity
};

export function LoadingScreen() {
  return (
    <div className="LoadingScreen">
      <motion.svg
        initial="default"
        animate="default"
        preserveAspectRatio="xMinYMid meet"
        className="Logo"
        viewBox="0 0 397.5 117.9"
      >
        <motion.rect
          fill="white"
          initial={{ opacity: 0, pathLength: 0 }}
          animate={{ pathLength: 1, opacity: 1 }}
          transition={transition}
          stroke="white"
          className="rect"
          width="128"
          height="131"
          rx="10"
          ry="10"
        ></motion.rect>
        <motion.path
          fill="transparent"
          className="Logo_Initial"
          stroke="black"
          strokeWidth={4}
          initial={{ pathLength: 0 }}
          animate={{ pathLength: 1 }}
          transition={transition}
          d="M42.114 29.863 c0.76776 1.7332 1.1562 3.6032 1.0711 5.4502 c-0.070548 1.8464 -0.61272 3.6425 -1.4733 5.2441 c-0.86436 1.6029 -2.0459 3.0209 -3.3698 4.2087 c-0.58283 0.5059 -1.1777 0.97494 -1.7968 1.3913 c-0.61458 0.40043 -1.2038 0.78054 -1.8336 1.1123 c-4.3365 2.3701 -9.2064 3.2707 -13.847 2.7539 l-1.5476 8.949 c-0.23514 1.2286 -5.3496 1.1986 -5.7119 -0.048985 l-4.2336 -27.3 c-2.5931 0.7659 -4.6346 1.1383 -4.7102 0.6057 l-0.081972 -0.32479 l-1.5794 -6.267 l4.048 -2.9815 c2.9198 -2.1508 6.1956 -3.511 9.4596 -4.1821 c3.2719 -0.67878 6.5574 -0.6813 9.7098 -0.08133 c3.1492 0.59361 6.1866 1.777 8.8872 3.5598 c0.66162 0.47162 1.3207 0.94194 1.9417 1.4612 l0.9057 0.81672 c0.30697 0.27392 0.58025 0.53959 0.88722 0.86436 c1.3684 1.4237 2.5086 3.0305 3.2745 4.7681 z M32.395 36.947 c0.23514 -0.94002 -0.086544 -1.9011 -0.70812 -2.4604 c-0.29807 -0.28664 -0.63492 -0.49195 -0.9597 -0.63624 c-0.25166 -0.16652 -0.61584 -0.32608 -0.89736 -0.49892 c-0.31459 -0.15381 -0.6495 -0.27838 -0.96348 -0.42011 c-1.3315 -0.47666 -2.7889 -0.68256 -4.2234 -0.6171 c-0.24404 0.0089064 -0.48557 0.038789 -0.72708 0.065508 l-1.9811 11.456 c3.0666 -0.46207 5.9407 -1.7644 8.1132 -3.6463 c0.34763 -0.28283 0.6711 -0.61458 0.97362 -0.91392 c0.28858 -0.29807 0.54088 -0.6171 0.7722 -0.92916 c0.29174 -0.46013 0.49447 -0.9273 0.60126 -1.3989 z"
        ></motion.path>
        <motion.path
          className="Logo_Text"
          d="M11.867 19.412 c5.6612 0 10.266 4.6056 10.266 10.267 s-4.6056 10.267 -10.267 10.267 c-2.1837 0 -4.2088 -0.68764 -5.8744 -1.8543 l0 7.1249 c0 1.2128 -0.98328 2.196 -2.196 2.196 s-2.196 -0.98328 -2.196 -2.196 l0 -23.608 c0 -1.2128 0.98328 -2.196 2.196 -2.196 c1.1027 0 2.013 0.81364 2.1697 1.873 c1.6709 -1.1782 3.7059 -1.873 5.9012 -1.873 z M11.867 35.5528 c3.2392 0 5.8744 -2.6353 5.8744 -5.8744 s-2.6353 -5.8744 -5.8744 -5.8744 s-5.8744 2.6353 -5.8744 5.8744 s2.6353 5.8744 5.8744 5.8744 z M42.446 19.412 c1.2128 0 2.196 0.98328 2.196 2.196 l0 16.196 c0 1.2128 -0.98328 2.196 -2.196 2.196 c-1.1071 0 -2.0201 -0.81968 -2.1716 -1.885 c-1.677 1.1856 -3.721 1.885 -5.9264 1.885 c-5.6764 0 -10.294 -4.6176 -10.294 -10.294 s4.6176 -10.294 10.294 -10.294 c2.2054 0 4.2492 0.69944 5.9264 1.885 c0.15152 -1.0654 1.0645 -1.885 2.1716 -1.885 z M34.348 35.608 c3.2543 0 5.902 -2.6476 5.902 -5.902 s-2.6476 -5.902 -5.902 -5.902 s-5.902 2.6476 -5.902 5.902 s2.6476 5.902 5.902 5.902 z M54.5684 19.412 c4.4004 0 7.98 3.5802 7.98 7.9804 l0 10.412 c0 1.2128 -0.98328 2.196 -2.196 2.196 s-2.196 -0.98328 -2.196 -2.196 l0 -10.412 c0 -1.9784 -1.6094 -3.5881 -3.5881 -3.5881 s-3.5881 1.6094 -3.5881 3.5881 l0 10.412 c0 1.2128 -0.98328 2.196 -2.196 2.196 s-2.196 -0.98328 -2.196 -2.196 l0 -16.196 c0 -1.2128 0.98328 -2.196 2.196 -2.196 c0.78592 0 1.4733 0.4142 1.8615 1.0349 c1.1592 -0.65744 2.4975 -1.0349 3.9227 -1.0349 z M82.859 19.412 c1.2128 0 2.1961 0.98324 2.1961 2.196 l0 15.537 c0 5.6612 -4.6056 10.267 -10.267 10.267 c-1.2128 0 -2.196 -0.98328 -2.196 -2.196 s0.98328 -2.196 2.196 -2.196 c2.8933 0 5.2992 -2.1046 5.7808 -4.862 c-1.6476 1.1269 -3.6384 1.7876 -5.7808 1.7876 c-5.6612 0 -10.267 -4.6056 -10.267 -10.267 s4.6056 -10.267 10.267 -10.267 c2.1952 0 4.23 0.69476 5.9008 1.873 c0.15676 -1.0593 1.067 -1.873 2.1697 -1.873 z M74.789 35.5528 c3.2392 0 5.8744 -2.6353 5.8744 -5.8744 s-2.6353 -5.8744 -5.8744 -5.8744 s-5.8744 2.6353 -5.8744 5.8744 s2.6353 5.8744 5.8744 5.8744 z M97.27000000000001 19.412 c5.6764 0 10.294 4.6176 10.294 10.294 s-4.6176 10.294 -10.294 10.294 s-10.294 -4.6176 -10.294 -10.294 s4.6176 -10.294 10.294 -10.294 z M97.27000000000001 35.608 c3.2543 0 5.902 -2.6476 5.902 -5.902 s-2.6476 -5.902 -5.902 -5.902 s-5.902 2.6476 -5.902 5.902 s2.6476 5.902 5.902 5.902 z M119.969 35.608 c1.2128 0 2.1961 0.98332 2.1961 2.1961 s-0.98328 2.196 -2.196 2.196 c-5.7668 0 -10.459 -4.692 -10.459 -10.459 l0 -15.345 c0 -1.2128 0.98328 -2.196 2.196 -2.196 s2.196 0.98328 2.196 2.196 l0 15.345 c0 3.3452 2.7215 6.0668 6.0668 6.0668 z"
          fill="transparent"
          stroke="white"
          initial={{ pathLength: 0 }}
          animate={{ pathLength: 1 }}
          transition={transition}
        />
      </motion.svg>
      <style jsx>{`
        .LoadingScreen {
          position: absolute;
          background: black;
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100%;
          height: 100%;
          flex-direction: column;
        }
        .LoadingScreen :global(svg) {
          width: 50%;
          height: auto;
        }
        .LoadingScreen :global(.Logo_Text) {
          transform: matrix(
            2.177239787401708,
            0,
            0,
            2.177239787401708,
            131.51728966460354,
            -6.127093392097748
          );
        }
        .LoadingScreen :global(.rect) {
          transform: matrix(0.9, 0, 0, 0.9, 0, 0);
        }
        .LoadingScreen :global(.Logo_Initial) {
          transform: matrix(
            2.176795137589935,
            0,
            0,
            2.176795137589935,
            7.469775473635343,
            -26.080250293100924
          );
        }
      `}</style>
    </div>
  );
}
